import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { Module, type ReferenceBasketVersion, selectReferenceBasketVersions } from '~/PriceReferencing';
import { Update } from '~/SkMaxPrice/reducer';
import { State } from '~/Store';
import { Statuses } from '~/UI/SaveActivityIndicator/SaveActivityIndicator';

import ParametersPanel from './ParametersPanel';

interface OwnProps {
	group: UserProductGroup;
}

const selectUpdateStatus = memoizeOne((groupId: string, update: Update | null) => {
	if (update?.groupId !== groupId) {
		return null;
	}

	switch (update.state.name) {
		case 'scheduled':
		case 'fetching':
			return Statuses.saving;
		case 'updated':
			return Statuses.saved;
		case 'failed':
			return Statuses.failed;
		default:
			return null;
	}
});

function mapStateToProps({ skMaxPrice, priceReferencing }: State, { group }: OwnProps) {
	return {
		updateStatus: selectUpdateStatus(group.id, skMaxPrice.update),
		versions: selectReferenceBasketVersions(priceReferencing, Module.skMaxPrice),
	};
}

export default connect(mapStateToProps)(ParametersPanel);
